<template>
  <a-modal :visible="visible" :wrap-class-name="$style.modalSync" :closable="false">
    <p class="mt-2">
      {{ $t('invoice.export_excel') }}
    </p>
    <div>
      <label>{{ $t('invoice.order_date') }}</label>
      <a-range-picker
        class="date-container w-100"
        :ranges="ranges"
        :format="dateFormat"
        :value="[startDate, endDate]"
        :placeholder="[
          $t('dashboardContent.start_date'),
          $t('dashboardContent.end_date'),
        ]"
        :disabled-date="disabledDate"
        :disabled="isLoading"
        allow-clear
        @change="onChangeDate"
      >
        <DateIcon slot="suffixIcon" style="color: #999999" />
      </a-range-picker>
    </div>
    <div class="mt-3">
      <label>{{ $t('invoice.payment_status') }}</label>
      <a-select
        v-model="statusPayment"
        class="w-100 select-antd-default filter"
        :placeholder="$t('finance.payment_status')"
        :options="paymentFilterState"
        @change="e => statusPayment = e"
      />
    </div>
    <template #footer>
      <a-button key="back" :disabled="isLoading" class="mr-2" @click="typeof back !== 'undefined' && back(), resetData(), onClose()">
        {{ $t('utils.cancel') }}
      </a-button>
      <a-button key="submit" :disabled="isLoading || !startDate" type="primary" @click="onSubmitModal()">
        {{ $t('invoice.export_excel') }}
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import getQueryParam from '@/utils/getQueryParam'
import DateIcon from '@/components/Icons/DateV2.vue'
import invoice from '../composables/invoice'

export default {
  name: 'ModalExportExcel',
  components: {
    DateIcon,
  },
  mixins: [getQueryParam],
  props: {
    visible: Boolean,
    back: Function,
    onClose: Function,
    isLoading: Boolean,
  },
  setup() {
    const {
      paymentFilterState,
    } = invoice()

    return {
      paymentFilterState,
    }
  },
  data() {
    return {
      dateFormat: 'DD MMMM YYYY',
      startDate: '',
      endDate: '',
      statusPayment: '',
    }
  },
  computed: {
    integration() {
      return this.$store.state.integration
    },
    ranges() {
      return {
        [this.$t('invoice.today')]: [this.$moment(), this.$moment()],
        [this.$t('invoice.this_month')]: [this.$moment().startOf('month'), this.$moment().endOf('month')],
        [this.$t('invoice.this_year')]: [this.$moment().startOf('year'), this.$moment().endOf('year')],
        [this.$t('invoice.last_7_days')]: [this.$moment().subtract(7, 'days'), this.$moment()],
        [this.$t('invoice.last_30_days')]: [this.$moment().subtract(1, 'month'), this.$moment()],
        [this.$t('invoice.last_1_year')]: [this.$moment().subtract(1, 'year'), this.$moment()],
      }
    },
  },
  methods: {
    to(url) {
      const route = typeof url === 'object' ? url : { path: url }
      route.query = {
        ...this.to.query,
        ...this.getQueryParam({ ...this.$route.query }),
        ...url.params?.query,
      }
      
      return route
    },
    disabledDate(current) {
      return current && current > this.$moment().endOf('day')
    },
    onChangeDate(date) {
      this.startDate = date[0]
        ? this.$moment(date[0]).format(this.formatDate)
        : ''
      this.endDate = date[1]
        ? this.$moment(date[1]).format(this.formatDate)
        : ''
    },
    onSubmitModal() {
      const selectedData = {
        startDate: this.startDate,
        endDate: this.endDate,
        statusPayment: this.statusPayment,
      }
      this.$emit('handleSubmitModal', selectedData)
      this.resetData()
    },
    resetData() {
      this.startDate = ''
      this.endDate = ''
      this.statusPayment = ''
    },
  },
}
</script>

<style lang="scss" module>
// @import './style.module.scss';
</style>